export const name = '$gzFilters';

/**
 * @ngdoc service
 * @name gazelle.components.filters.service:$gzFilters
 *
 * @description
 * The $gzFilters service provides helpers to use with filter definitions
 *
 */

export default function $gzFilters(
  $mdDialog,
  $translate,
  $gzFields,
  moment
) {
  //noinspection BadExpressionStatementJS
  'ngInject';
  let vm = this;


  var unitTest = {
  };

  var service = {
    openFilterDialog: openFilterDialog,
    openSaveFilterDialog: openSaveFilterDialog,
    createFiltersObject: createFiltersObject,
    mergeFilters: mergeFilters,
    setInternalId: setInternalId,
    evaluateOr: evaluateOr,
    evaluateAnd: evaluateAnd,
    evaluateExpression: evaluateExpression,
    getServerFilters: getServerFilters,
    unitTest: unitTest
  };

  activate();
  return service;

  function activate() {
  }

  //
  // Public functions
  //
  function openFilterDialog(pairingId, columns, filters, columnId = undefined, showServerIndicator = true) {
    return $mdDialog.show({
      template: require('../../components/filters/filter-dialog/filter-dialog.jade'),
      controller: 'gzFilterDialogController',
      controllerAs: 'vm',
      multiple: true,
      locals: {
        pairingId: pairingId,
        columns: columns,
        filters: filters,
        columnId: columnId,
        showServerIndicator: showServerIndicator,
      }
    });
  }

  function openSaveFilterDialog(pairingId, filters) {
    return $mdDialog.show({
      template: require('../../components/filters/save-dialog/save-dialog.jade'),
      controller: 'gzSaveDialogController',
      controllerAs: 'vm',
      locals: {
        pairingId: pairingId,
        filters: filters
      }
    })
    .then(function(savedFilter) {
      return savedFilter;
    });
  }

  function createFiltersObject(filters = undefined) {
    let myFilters;
    if (filters && (filters.userFilter || filters.quickFilter)) {
      let userFilter = _.get(filters, 'userFilter');
      let quickFilter = _.get(filters, 'quickFilter');
      let namedFilter = _.get(filters, 'namedFilter');
      let mergedFilter = _.get(filters, 'mergedFilter');
      myFilters = {};
      if (userFilter !== undefined) {
        myFilters.userFilter = userFilter;
      }
      if (quickFilter !== undefined) {
        myFilters.quickFilter = quickFilter;
      }
      if (namedFilter !== undefined) {
        myFilters.namedFilter = namedFilter;
      }
      if (mergedFilter !== undefined) {
        myFilters.mergedFilter = mergedFilter;
      }
    }
    else {
      myFilters = {};
      myFilters.userFilter = {and:[]};
      myFilters.mergedFilter = {and: []};
    }

    return myFilters;
  }

  function setInternalId(filters, expression) {
    let nextIndex = _.get(filters, 'internalId', 0);
    expression.internalId = nextIndex++;
    filters.internalId = nextIndex;
  }

  function mergeFilters(filters) {
    let userFilter = _.get(filters, 'userFilter.and', []);
    let namedFilter = _.get(filters, 'namedFilter.and', []);
    let adhocFilter = _.get(filters, 'adhocFilter.and', []);
    let mergedFilter = [];
    let userColIds = [];
    let nextFilterIndex = _.get(filters, 'nextIndex');
    if (!nextFilterIndex) {
      nextFilterIndex = 0;
    }

    let currentId;
    _.forEach(userFilter, filter => {
      if (filter.and) {
        currentId = filter.and[0].columnId;
        _.forEach(filter.and, andFilter =>{
          _.set(andFilter, 'internalId', nextFilterIndex++);
        });
      }
      else if (filter.or) {
        currentId = filter.or[0].columnId;
        _.forEach(filter.or, orFilter =>{
          _.set(orFilter, 'internalId', nextFilterIndex++);
        });
      }
      else {
        currentId = filter.columnId;
        filter.internalId = nextFilterIndex++;
      }
      userColIds.push(currentId);
      mergedFilter.push(_.cloneDeep(filter));
    });

    _.forEach(adhocFilter, filter => {
      _.set(filter, 'internalId', nextFilterIndex++);
    });

    _.forEach(namedFilter, filter => {
      if (filter.and) {
        currentId = filter.and[0].columnId;
        _.forEach(filter.and, andFilter => {
          _.set(andFilter, 'internalId', nextFilterIndex++);
        });
      }
      else if (filter.or) {
        currentId = filter.or[0].columnId;
        _.forEach(filter.or, orFilter => {
          _.set(orFilter, 'internalId', nextFilterIndex++);
        });
      }
      else {
        filter.internalId = nextFilterIndex++;
        currentId = filter.columnId;
      }

      if (userColIds.indexOf(currentId) === -1) {
        mergedFilter.push(_.cloneDeep(filter));
      }
    });

    if (filters) {
      filters.nextIndex = nextFilterIndex;
    }

    _.set(filters, 'mergedFilter.and', mergedFilter);
    return mergedFilter;
  }

  ///////////////Filter Functions////////////////////////
  ///////////////////////////////////////////////////////
  function evaluateOr(or, node, columns) {
    let pass = false;
    _.forEach(or, item => {
      let test = false;
      if (item.or) {
        test = evaluateOr(item.or, node, columns);
      }
      else if (item.and) {
        test = evaluateAnd(item.and, node, columns);
      }
      else {
        test = evaluateExpression(item, node, columns);
      }

      if (test) {
        pass = true;
        return false;
      }
    });

    return pass;
  }

  function evaluateAnd(and, node, columns) {
    let pass = true;
    _.forEach(and, item => {
      let test = true;
      if (item.or) {
        test = evaluateOr(item.or, node, columns);
      }
      else if (item.and) {
        test = evaluateAnd(item.and, node, columns);
      }
      else {
        test = evaluateExpression(item, node, columns);
      }

      if (!test) {
        pass = false;
        return false;
      }
    });

    return pass;
  }

  function evaluateExpression(filter, node, columns) {
    let pass = false;
    let column = _.find(columns, {id: filter.columnId});
    if (column) {
      let isServerFilter = _.get(column, 'options.filter.isServerFilter', false);
      if (isServerFilter) {
        //Assume the server has already filtered things out
        return true;
      }

      switch (column.type) {
        case 'string':
          pass = evaluateStringFilter(filter, node, column);
          break;
        case 'number':
          pass = evaluateNumberFilter(filter, node, column);
          break;
        case 'date':
          pass = evaluateDateFilter(filter, node, column);
          break;
        case 'mapped':
          pass = evaluateMappedFilter(filter, node, column);
          break;
        case 'duration':
          pass = evaluateDurationFilter(filter, node, column);
          break;
        default:
          // Ignore?
          break;
      }
    }
    return pass;
  }

  function evaluateStringFilter(filter, node, column) {
    let rawValue = _.get(node.data, column.field.path);
    if (rawValue) { rawValue = '' + rawValue;}
    let value = _.get(node.data, 'internal.display.' + column.id);
    if (!value) {
      value = $gzFields.getValue(rawValue, node.data, column);
      if (value) { value = '' + value;}
      _.set(node.data, 'internal.display.' + column.id, value);
    }
    else {
      value = '' + value;
    }

    let filterValue = filter.value;
    if (filter.op !== 'equals' &&
      filter.op !== 'notEqual' &&
      filter.op !== 'isEmpty' &&
      filter.op !== 'isNotEmpty') {
      if (value) {
        value = value.toLocaleLowerCase();
      }
      if (filterValue) {
        filterValue = filterValue.toLocaleLowerCase();
      }
    }
    switch(filter.op) {
      case 'equals':
        return value === filterValue;
      case 'notEqual':
        return value !== filterValue;
      case 'isEmpty':
        return value === undefined || value === null || value === '';
      case 'isNotEmpty':
        return value !== undefined && value !== null && value !== '';
      case 'contains':
        if (!value) {
          return false;
        }
        return value.indexOf(filterValue) >= 0;
      case 'startsWith':
        if (!value) {
          return false;
        }
        return value.startsWith(filterValue);
      case 'endsWith':
        if (!value) {
          return false;
        }
        return value.endsWith(filterValue);
    }
  }

  function evaluateNumberFilter(filter, node, column) {
    let rawValue = _.get(node.data, column.field.path);
    let value = _.get(node.data, 'internal.display.' + column.id);
    if (!value) {
      value = $gzFields.getValue(rawValue, node.data, column);
      _.set(node.data, 'internal.display.' + column.id, value);
    }

    if (value) {
      value = parseInt(value);
    }

    switch(filter.op) {
      case 'equals':
        return value === filter.value;
      case 'notEqual':
        return value !== filter.value;
      case 'isEmpty':
        return value === undefined || value === null || value === '';
      case 'isNotEmpty':
        return value !== undefined && value !== null && value !== '';
      case 'greaterThan':
        return value > filter.value;
      case 'greaterThanOrEqual':
        return value >= filter.value;
      case 'lessThan':
        return value < filter.value;
      case 'lessThanOrEqual':
        return value <= filter.value;
      case 'between':
        let begin = filter.begin;
        let end = filter.end;
        if (begin > end) {
          begin = filter.end;
          end = filter.begin;
        }
        return value >= begin && value <= end;
    }
  }

  function evaluateDateFilter(filter, node, column) {
    let rawValue = _.get(node.data, column.field.path);
    let isEmpty = false;
    if (rawValue === undefined || rawValue === null || rawValue === '') {
      isEmpty = true;
    }
    let value = _.get(node.data, 'internal.display.' + column.id);
    if (!value) {
      value = $gzFields.getValue(rawValue, node.data, column);
      _.set(node.data, 'internal.display.' + column.id, value);
    }

    let begin;
    let end;
    let test;
    switch(filter.op) {
      case 'equals':
        if (isEmpty) return false;
        return moment(rawValue).isSame(moment(filter.value), 'day');
      case 'notEqual':
        if (isEmpty) return true;
        return !moment(rawValue).isSame(moment(filter.value), 'day');
      case 'isEmpty':
        return isEmpty;
      case 'isNotEmpty':
        return !isEmpty;
      case 'greaterThan':
        if (isEmpty) return false;
        return moment(rawValue).isAfter(moment(filter.value), 'day');
      case 'greaterThanOrEqual':
        if (isEmpty) return false;
        return moment(rawValue).isSameOrAfter(moment(filter.value), 'day');
      case 'lessThan':
        if (isEmpty) return false;
        return moment(rawValue).isBefore(moment(filter.value), 'day');
      case 'lessThanOrEqual':
        if (isEmpty) return false;
        return moment(rawValue).isSameOrBefore(moment(filter.value), 'day');
      case 'between':
        if (isEmpty) return false;
        begin = filter.begin;
        end = filter.end;
        if (filter.begin > filter.end) {
          begin = filter.end;
          end = filter.begin;
        }
        return moment(rawValue).isSameOrAfter(moment(begin), 'day') && moment(rawValue).isSameOrBefore(moment(end), 'day');
      case 'today':
        if (isEmpty) return false;
        return moment(rawValue).isSame(moment(), 'day');
      case 'tomorrow':
        if (isEmpty) return false;
        return moment(rawValue).isSame(moment().add(1, 'd'), 'day');
      case 'yesterday':
        if (isEmpty) return false;
        return moment(rawValue).isSame(moment().subtract(1, 'd'), 'day');
      case 'thisWeek':
        if (isEmpty) return false;
        test = moment(rawValue);
        begin = moment().startOf('week');
        end = moment().endOf('week');
        return test.isSameOrAfter(begin, 'day') && test.isSameOrBefore(end, 'day');
      case 'nextWeek':
        if (isEmpty) return false;
        test = moment(rawValue);
        begin = moment().startOf('week');
        end = moment().endOf('week');
        let beginNextWeek = begin.add(1, 'w');
        let endNextWeek = end.add(1, 'w');
        return test.isSameOrAfter(beginNextWeek, 'day') && test.isSameOrBefore(endNextWeek, 'day');
      case 'lastWeek':
        if (isEmpty) return false;
        test = moment(rawValue);
        begin = moment().startOf('week');
        end = moment().endOf('week');
        let beginLastWeek = begin.subtract(1, 'w');
        let endLastWeek = end.subtract(1, 'w');
        return test.isSameOrAfter(beginLastWeek, 'day') && test.isSameOrBefore(endLastWeek, 'day');
      case 'future':
        if (isEmpty) return false;
        return moment(rawValue).isAfter(moment(), 'day');
      case 'past':
        if (isEmpty) return false;
        return moment(rawValue).isBefore(moment(), 'day');
      case 'lastSevenDays':
        if (isEmpty) return false;
        let today = moment();
        let sevenDayBefore = moment().subtract(7,'day');
        return moment(rawValue).isSameOrAfter(moment(sevenDayBefore), 'day') && moment(rawValue).isSameOrBefore(moment(today), 'day');
    }
  }

  function evaluateMappedFilter(filter, node, column) {
    let value = _.get(node.data, column.field.path, 0);
    //TODO: Use comparator if necessary
    switch(filter.op) {
      case 'equals':
        return value === filter.value;
      case 'notEqual':
        return value !== filter.value;
      case 'greaterThan':
        return value > filter.value;
      case 'greaterThanOrEqual':
        return value >= filter.value;
      case 'lessThan':
        return value < filter.value;
      case 'lessThanOrEqual':
        return value <= filter.value;
    }
  }

  function evaluateDurationFilter(filter, node, column) {
    let rawValue = _.get(node.data, column.field.path);
    let valueRenderer = _.get(column, 'field.callbacks.valueRenderer');
    if (valueRenderer) {
      rawValue = valueRenderer(rawValue, node.data, column);
    }
    let value = _.get(node.data, 'internal.display.' + column.id);
    if (!value) {
      value = $gzFields.getValue(rawValue, node.data, column);
      _.set(node.data, 'internal.display.' + column.id, value);
    }

    // let rounded =  rawValue - (rawValue % 1000);
    switch(filter.op) {
      case 'equals':
        return rawValue === filter.value;
      case 'notEqual':
        return rawValue !== filter.value;
      case 'isEmpty':
        return rawValue === undefined || rawValue === null || rawValue === '';
      case 'isNotEmpty':
        return rawValue !== undefined && rawValue !== null && rawValue !== '';
      case 'greaterThan':
        return rawValue > filter.value;
      case 'greaterThanOrEqual':
        return rawValue >= filter.value;
      case 'lessThan':
        return rawValue < filter.value;
      case 'lessThanOrEqual':
        return rawValue <= filter.value;
      case 'between':
        return true;
    }

    return true;
  }

  ///////////////Server Filter Functions/////////////////
  ///////////////////////////////////////////////////////
  function getServerFilters(filters, gridOptions) {
    let sFilters = {and:[]};
    let serverAND = _.get(gridOptions, 'grid.options.filter.serverFilterAND', false);
    let serverOR = _.get(gridOptions, 'grid.options.filter.serverFilterOR', false);
    let serverRecurse = _.get(gridOptions, 'grid.options.filter.serverFilterRecurse', false);
    let mergedFilter = _.get(filters, 'mergedFilter.and', []);
    markServerFilters(mergedFilter, serverAND, serverOR, serverRecurse, gridOptions.columns);
    if (serverAND) {
      _.forEach(filters.mergedFilter.and, item => {
        if (item.isServerFilter) {
          sFilters.and.push(item);
        }
      });
    }
    else {
      // In this case, return back the first valid server filter
      for (let i=0; i<filters.mergedFilter.and.length; i++) {
        let item = filters.mergedFilter.and[i];
        if (item.isServerFilter && !item.or && !item.and) {
          sFilters.and.push(item);
          break;
        }
      }
    }

    return sFilters;
  }

  function markServerFilters(items, AND, OR, RECURSE, columns) {
    _.forEach(items, item => {
      if (RECURSE) {
        if (item.or) {
          if (OR) {
            markServerFilters(item.or, AND, OR, RECURSE, columns);
            item.isServerFilter = isServerRecurseFilter(item.or);
          }
          else {
            //Server doesn't support the OR concept so we can ignore
            item.isServerFilter = false;
          }
        }
        else if (item.and) {
          if (AND) {
            markServerFilters(item.and, AND, OR, RECURSE, columns);
            item.isServerFilter = isServerRecurseFilter(item.and);
          }
          else {
            //Server doesn't support the AND concept so we can ignore
            item.isServerFilter = false;
          }
        }
        else {
          item.isServerFilter = isServerFilter(item, columns);
        }
      }
      else {
        if (item.or || item.and) {
          // No Recursion concept so we can ignore
          item.isServerFilter = false;
        }
        else {
          item.isServerFilter = isServerFilter(item, columns);
        }
      }
    });
  }

  function isServerRecurseFilter(item) {
    // For now, we'll pass filters back to server only if everything in array isServerFilter
    let isServer = true;
    for(let i=0; i < item.length; i++) {
      if (!item[i].isServerFilter) {
        isServer = false;
      }
    }

    return isServer;
  }

  function isServerFilter(item, columns) {
    let found = _.find(columns, {id: item.columnId});
    if (found) {
      let SERVER = _.get(found, 'options.filter.isServerFilter', false);
      let supportsOp = true;
      let OPS = _.get(found, 'options.filter.serverOps');
      if (OPS) {
        supportsOp = OPS.indexOf(item.op) >= 0;
      }

      return SERVER && supportsOp;
    }
  }


  //
  // Private functions
  //
}
